import React from 'react';
import PropTypes from 'prop-types';
import { Button, withStyles } from '@material-ui/core';

const styles = theme => ({
    button: {
        marginRight: theme.spacing(2),
    },
});

const ButtonClear = ({
    title,
    classes,
    ...otherProps
}) => (
    <Button
        type="submit"
        size="large"
        variant="contained"
        color="primary"
        className={classes.button}
        {...otherProps}
    >
        {title}
    </Button>
);

ButtonClear.propTypes = {
    classes: PropTypes.objectOf(PropTypes.any).isRequired,
    title: PropTypes.string.isRequired,
};
export default withStyles(styles)(ButtonClear);
